<template>
    <v-flex class="pagina-curso" id="pagina-curso" xs12 fill-height
                        v-on:scroll="handleScroll">
        <header-app></header-app>
        <icono-glosario-app/>
        <nav-menu-app :mod="mod"></nav-menu-app>
        <scrolldown-app :vistodown="visiblescroll"/>
        <v-container    class="contenido" id="contenido" 
                        v-if="$route.params.unipage!=10"
            >
            <transition name="fade">
                    <component key="item" :is="'mod' + $route.params.unipage + '-app'" :arrayvisto="arrayaction"></component>                
            </transition>
        </v-container>
        <v-container class=" contenido-info" id="contenido-info" 
                    v-on:scroll="handleScrollInfografia" 
                    v-if="$route.params.unipage==10">
            <div class=" contenido">
                <component key="item"
                    :valuescroll="valuescroll"
                    :totalscroll="totalscroll"
                    :hescroll="hescroll"
                    :is="'mod' + $route.params.unipage + '-app'"/>
            </div>
        </v-container>
    </v-flex>
</template>
<script>
    import mod0 from "./mod0";
    import mod1 from "./mod1";
    import Infografia from '../../components/infografia.vue';
    export default {
        components: {
            "mod0-app": mod0,
            "mod1-app": mod1,      
        },
        data() {
            return {
                offsetTop: 0,
                noOfPages: 2,
                mod: {
                    modurl: "ruta"
                },
                verdialogo:0,
                nombreAnimacion:'',
                cambioAction:'',
                arrayaction:false,
                visiblescroll:true,
                mostrarLetrero:Array(4).fill(false),
                textoMensaje:'',
                modal:false,
                textoBtn:'',
                lista:[],
                valuescroll:0,
                totalscroll:0,
                hescroll:0
            };
        }, 
        computed: {
            currentPage() {
              return Math.floor(this.$route.params.unipage);
            },
            subModName() {
                return this.$store.state.subTema;
            },
        },      
        methods: {
            tomarvalores(){
            var itemscroll = document.getElementById('pagina-curso')
            var valuescroll = itemscroll.scrollTop
            if(valuescroll === 0){
                this.visiblescroll = true
            }
            },
            handleScroll(){
            var itemscroll = document.getElementById('pagina-curso')
            var valuescroll = itemscroll.scrollTop
            var totalscroll = itemscroll.offsetHeight
            var hescroll = itemscroll.scrollHeight
            var totalsc =  (hescroll - totalscroll ) - 10
            this.$store.state.actualScroll = totalsc
            console.log(totalsc +' ddd '+  valuescroll )
            if(valuescroll >= totalsc){
                this.arrayaction = true
                this.$store.state.scrollEnd = false
                this.visiblescroll = false
                this.$store.commit('nextShow', true)
                this.$store.commit('scrollShow', false)
            }else{
                this.$store.state.scrollEnd =  true
                this.visiblescroll = true
                this.$store.commit('nextShow', false)
                this.$store.commit('scrollShow', true)
            }
            },
            irpantalla() {
            this.$store.commit("screenTrack", [this.currentPage, this.noOfPages]);
            var pagActual = this.$route.params.unipage;
            console.log('Pagina actual: ' + pagActual);
            if (this.$route.params.unipage == '1') {
                    this.$store.commit('nextShow', false)
                }
            switch (pagActual) {
                case (''):
                    this.arrayaction = false
                    break;
                default:
                    this.arrayaction = false

            }
            },
            handleScrollInfografia(){
                var itemscroll = document.getElementById('contenido-info')
                this.valuescroll = itemscroll.scrollTop
                this.totalscroll = itemscroll.offsetHeight 
                this.hescroll = itemscroll.scrollHeight
                var totalsc =  this.hescroll - this.totalscroll 
                console.log(totalsc +' ddd '+  this.valuescroll )
            }
        },
        // mounted y updated: Carga el número de pantallas en el store para que las flechas de navegación funcionen
        mounted() {
            this.irpantalla();
            this.tomarvalores();
            this.$store.commit("screenTrack", [this.currentPage, this.noOfPages]);
        },
        updated() {
            this.irpantalla();
            this.tomarvalores();
            this.$store.commit("screenTrack", [this.currentPage, this.noOfPages]);
        },
    };
</script>
<style lang="scss" scoped>
    // NOT SCOPED !!
    @import "../../sass/globals";
    .pagina-curso {
        background-image: url("../../assets/fondo/fondoopacity.svg");
        background-repeat: no-repeat;
        background-position: bottom right;
        background-size: 20%;
        //background: #ffffff;
        height: 100vh;
        overflow-y: auto;
        transition: all 0.3s ease-in-out;
        padding: 0px;

        .contenido {
            max-width: 100%;
            //width: 955px;
            margin: auto;
            position: relative;
            overflow: auto;
            min-height: calc(100vh - 100px);
            height: auto;
            padding: 0px;
            margin-top: 50px;  
            overflow: hidden;



        }
        @media screen and (max-width: 700px) {
            background-size: 70%;
        }
        @media screen and (max-width: 500px) {
            background-size: 90%;
        }
    }
.fade-enter-active, .fade-leave-active {
    transition: all 2s;
    position: absolute;
    max-height: 100%;
    min-height: 100%;
    max-width: calc(100% - 0px);
    min-width: calc(100% - 0px);
    overflow: hidden;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
@media (max-width: 700px) {
    .pagina-curso{
        background-image: url("");
    }
}


/* Estilos infografia */
/**/

h2.titulo-info{
  font-size: 1.7rem;
  font-family: FontBase-SemiBold;
  color: $color-primary;
}


.contenido-info{
    max-width: 100%;
    margin: auto;
    position: relative;
    overflow: auto;
    height: calc(100vh + 100px);
    max-height: auto;
    padding: 0px 15px 0px 15px;
            scrollbar-color: #fafafa #fafafa;
    scrollbar-width: 10px;
    @media screen and (max-width: 500px){
        max-width: 100%;                
    }
}
</style>
